import React, { useState } from "react";
import { Card } from "antd";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/landingFeatures/explorer.png";
import FooterNuJobs from "../footerNuJobs";
import { Button } from "antd";
import { MenuOutlined,  CloseOutlined } from "@ant-design/icons";

import "./nujobscontact.scss";

function NuJobsContact(props) {
  const navigate = useNavigate();
  const [contactType, setContactType] = useState("");
  const [message, setMessage] = useState("");
  const [name, setName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const inputStyle = {
    width: "100%",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #d1d5db",
    marginTop: "5px",
  };
  const onChange = (key) => {
    //console.log(key);
  };

  const handleContact = (type) => {
    setContactType(type);

    if (type === "demo") {
      setMessage("Hi Team,\nI would like to request a demo for NuJobs");
    }

    if (type === "sales") {
      setMessage("Hi Team,\nI want to discuss pricing and plans.");
    }

    if (type === "support") {
      setMessage("Hi Team,\n I have a query -");
    }

    // scroll to form
    setTimeout(() => {
      document
        .getElementById("contact-form")
        ?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  const handleSignin = () => {
    navigate("/nujobsotpprocess", {
      state: {
        reason: "start",
        trigger: "signin",
      },
    });
  };


  const handlePostJobs = () => {
    navigate("/otpprocess/nujobs", {
      state: {
        reason: "start",
        trigger: "signin",
      },
    });    
  };

  return (
    <div className="nujobscontact-wrapper">
       <div className="jobListing-header"> 
          <div className="jobListing-header-logo">
              <img className="jobListing-logo-img"src={logo} />
          </div>
          <div className="header-menu">
            <ul className="header-menu">
              <li >
                <a href="/nujobs">Jobs</a>
              </li>
              <li>
                <a href="/nujobsemployerpage">For Employers</a>
              </li>      
              <li>
                <a href="/nujobscontact">Support</a>
              </li>                                                                   
            </ul>
          </div>
          <div
            className="jobListing-mobile-menu"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <CloseOutlined /> : <MenuOutlined />}
          </div>   
               
          <div className="header-sign">
            <Button className="sign-button" onClick={() => handleSignin()}>
              Candidate Sign In
            </Button>
            <Button className="job-button" onClick={() => handlePostJobs()}>
              Employers Sign In
            </Button>                                     
          </div>          
       </div>
        {mobileMenuOpen && (
          <div className="jobListing-mobile-menu-dropdown">
            <a
              href="/nujobs"
              onClick={() => setMobileMenuOpen(false)}
            >
              Jobs
            </a>

            <a
              href="/nujobsemployerpage"
              onClick={() => setMobileMenuOpen(false)}
            >
              Employers
            </a>

            <a
              href="/nujobscontact"
              onClick={() => setMobileMenuOpen(false)}
            >
              Support
            </a>

          </div>
        )}
      <div className="Nujobs-contact-wrapper">
        <div className="qhrflowlanding-features">
          <div
            style={{
              maxWidth: "900px",
              margin: "60px auto",
              textAlign: "center",
            }}
          >
            {/* HEADER */}
            <div style={{ marginBottom: "30px" }}>
              <h1 style={{ fontSize: "32px", fontWeight: 600 }}>
                Get Started with Nujobs
              </h1>
              <p style={{ color: "#6b7280", fontSize: "16px" }}>
                Whether you want a demo, pricing, or support — we’ll get back
                within 24 hours.
              </p>
            </div>

            {/* CARDS */}
            <div
              style={{
                display: "flex",
                gap: "34px",
                justifyContent: "center",
                flexWrap: "wrap",
                marginTop: "40px",
              }}
            >

              {/* SALES */}
              <Card
                hoverable
                style={{
                  width: 260,
                  textAlign: "center",
                  border:
                    contactType === "sales"
                      ? "2px solid #1677ff"
                      : "1px solid #f0f0f0",
                }}
              >
                <h3>Talk to Sales</h3>
                <p style={{ color: "#6b7280" }}>
                  Get pricing, plans, and custom solutions.
                </p>
                <Button
                  shape="round"
                  block
                  onClick={() => handleContact("sales")}
                >
                  Contact Sales
                </Button>
              </Card>

              {/* SUPPORT */}
              <Card
                hoverable
                style={{
                  width: 260,
                  textAlign: "center",
                  border:
                    contactType === "support"
                      ? "2px solid #1677ff"
                      : "1px solid #f0f0f0",
                }}
              >
                <h3>Support</h3>
                <p style={{ color: "#6b7280" }}>
                  Facing issues? We’ll help you quickly.
                </p>
                <Button
                  shape="round"
                  block
                  onClick={() => handleContact("support")}
                >
                  Get Help
                </Button>
              </Card>
            </div>

            {/* TRUST LINE */}
            <div style={{ marginTop: "30px", color: "#9ca3af" }}>
              ⚡ Fast response • No spam • Real human support.
              Whatsapp:+91-9591270077
            </div>
          </div>
        </div>
        {contactType && (
          <div
            id="contact-form"
            style={{
              marginTop: "50px",
              maxWidth: "900px",
              marginLeft: "auto",
              marginRight: "auto",
              background: "#ffffff",
              padding: "24px",
              borderRadius: "12px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              textAlign: "left",
            }}
          >
            <h3 style={{ marginBottom: "15px" }}>
              {contactType === "demo" && "Request Demo"}
              {contactType === "sales" && "Talk to Sales"}
              {contactType === "support" && "Support Request"}
            </h3>

            {/* NAME */}
            <div style={{ marginBottom: "12px" }}>
              <label>Name</label>
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter your name"
                style={inputStyle}
              />
            </div>

            {/* EMAIL */}
            <div style={{ marginBottom: "12px" }}>
              <label>Email</label>
              <input
                value={userEmail}
                onChange={(e) => setUserEmail(e.target.value)}
                placeholder="Enter your email"
                style={inputStyle}
              />
            </div>

            {/* MESSAGE */}
            <div style={{ marginBottom: "12px" }}>
              <label>Message</label>
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows={5}
                style={{ ...inputStyle, resize: "none" }}
              />
            </div>

            {/* BUTTON */}
            <div style={{ textAlign: "center", marginTop: "15px" }}>
              <Button
                type="primary"
                shape="round"
                size="large"
                onClick={() => {
                  alert("Message sent! (connect API next)");
                }}
              >
                Send Message
              </Button>
            </div>
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="landing-footer">
        <FooterNuJobs />
      </div>
    </div>
  );
}

export default NuJobsContact;
